import { API, Auth } from 'aws-amplify'


export const api = {
    auth() {
        return {
            getUser: () => Auth.currentAuthenticatedUser(),
            signIn: (email, password) => Auth.signIn(email, password),
            signOut: () => Auth.signOut(),
            signUp: (obj) => Auth.signUp(obj),
            forgotPassword: (email) => Auth.forgotPassword(email),
            recoveryPassword: (email, code, password) => Auth.forgotPasswordSubmit(email, code, password)
        }
    },
    company() {
        return {
            get: (companyId) => API.get('companies', `/getCompany/${companyId}`),
            update: (company) => API.post('companies', '/updateCompany', { body: company }),
        }
    },
    user() {
        return {
            get: () => API.get('users', '/getUser'),
            getUsersByCompany: (company_id) => API.get('users', `/getUsersInCompany/${company_id}`),
            updateUserCompany: (obj) => API.post('users', '/updateUserCompany', { body: obj }),
            deleteUser: (company_id, requested_user_id) => API.post('users', '/deleteUser', { body: { company_id, requested_user_id } }),
            invite: (obj) => API.post('users', '/inviteUser', { body: obj }),
            update: (user, obj) => Auth.updateUserAttributes(user, obj)
        };
    },
    sites() {
        return {
            get: (companyId) => API.get('websites', `/getWebsites/${companyId}`),
            getCompetitors: (parent_website_id) => API.get('websites', `/getWebsites/${parent_website_id}?competitor=true`),
            getOne: (websiteId) => API.get('websites', `/getWebsite/${websiteId}`),
            create: (obj) => API.post('websites', '/createWebsite', { body: obj }),
            update: (obj) => API.post('websites', '/updateWebsite', { body: obj }),
            delete: (company_id, website_id) => API.post('websites', '/removeWebsite', { body: { company_id, website_id } }),
            deleteCompetitor: (website_id, parent_website_id, company_id) => API.post('websites', '/removeWebsite', { body: { website_id, parent_website_id, company_id, competitor: true } }),
        };
    },
    stripe() {
        return {
            getProducts: () => API.get('stripe', '/getProducts'),
            subscribe: (price_id, company_id) => API.post('stripe', '/createSession', { body: { price_id, company_id } }),
            getSubscription: (company_id) => API.get('stripe', `/getSubscription/${company_id}`)
        }
    }
}
